import styled from "styled-components";

export const StyledColorPicker = styled.div<{ color: string }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  label.color-cont {
    height: 25px;
    width: 25px;
    border: 3px solid #ccc;
    background-color: ${({ color }) => color};
    margin-right: 10px;
  }
  input {
    // display: none;
    visibility: hidden;
    width: 0;
    height: 0;
  }
`;
